<template>
  <div class="row align-items-center justify-content-center shadow feature-wrapper rounded border my-2 p-3">
    <div class="col-lg-12">
      <p>{{ productFeatureNameWrapper(product, productFeature) }}</p>
    </div>
    <div class="col-lg-2" v-if="!isCheckbox">
      <input id="feature-product-image" type="hidden" @change="onFileChange"/>

      <div class="my-2">
        <img alt="" class="w-100 feature-image"
             :src="setFeatureImage"/>
      </div>

      <b-form-file
          browse-text="انتخاب عکس"
          @change="onFileChange"
          class="text-center"
          v-model="productFeature.featureImage"
          placeholder="انتخاب عکس"
          drop-placeholder="انتخاب عکس"
      ></b-form-file>

      <feature-remove-image-button :product-feature="productFeature" class="my-1"/>

    </div>

    <template v-if="productFeature.variation == 1">
      <div class="col-lg-3">
        <div class="form-group">
          <label for="feature-price">قیمت</label>
          <input type="text" v-model="productFeature.price" class="form-control" id="feature-price">
          <span class="d-block" v-if="productFeature.price">{{formatNumber(productFeature.price)}}</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group">
          <label for="feature-offer">تخفیف</label>
          <input type="text" v-model="productFeature.offer" class="form-control" id="feature-offer">
          <span class="d-block" v-if="productFeature.offer">{{formatNumber(productFeature.offer)}}</span>
        </div>
      </div>
      <div class="col-lg-3">

        <div class="form-group">
          <label for="feature-quantity">تعداد</label>
          <input type="text" v-model="productFeature.quantity" class="form-control" id="feature-quantity">
          <span class="d-block" v-if="productFeature.quantity">{{formatNumber(productFeature.quantity)}}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <normal-item-config :product="product" :feature-product="productFeature"/>
    </template>

    <div class="col-lg-1" v-if="!isCheckbox">
      <b-icon-trash @click="removeFeatureProduct()" class="h4"/>
    </div>

    <div class="col-lg-12 text-right" v-if="productFeature.variation == 1">
      <feature-item-extra :product="product" :product-feature="productFeature"/>
    </div>


  </div>
</template>

<script>
import {defaultProductImage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import NormalItemConfig from "./NormalItemConfig.vue";
import FeatureItemExtra from "./FeatureItemExtra.vue";
import FeatureRemoveImageButton from "./FeatureRemoveImageButton.vue";
import {productFeatureName, checkValueIsNumber} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProductFeatureItem",
  components: {FeatureRemoveImageButton, FeatureItemExtra, NormalItemConfig},
  props: {
    productFeature: {},
    product: {},
  },
  data() {
    return {
      defaultProductImage
    }
  },
  computed: {
    feature() {
      return this.productFeature.feature
    },
    productFeatures() {
      return this.product.features
    },
    setFeatureImage() {
      let preview = this.productFeature.preview
      let featureImage = this.productFeature.image;
      let defaultImage = this.defaultProductImage

      if (preview != null) {
        return preview
      }

      if (featureImage == null) {
        return defaultImage
      }
      return featureImage
    },
    isCheckbox() {
      return Array.isArray(this.productFeature)
    }
  },
  methods: {
    formatNumber,
    checkValueIsNumber,
    productFeatureName,
    removeItemInFront(feature) {
      this.product.features.forEach((item, index) => {
        if (item.id == feature.id) {
          console.log(item.id, 'removeFeatureProduct', feature)
          this.product.features.splice(index, 1)
        }
      })
    },
    removeFeatureProduct() {
      const feature = this.productFeature

      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {

        const form = {
          product_id: feature.product_id,
          feature_product: [feature.id],
        }

        const isItemSavedBefore = this.checkValueIsNumber(feature.id); // we set local item id as hash and cant be parse to int
        console.log(isItemSavedBefore, feature.id)
        if (isItemSavedBefore) {
          this.$store.dispatch('Product/deleteProductFeature', form).then(res => {
            this.removeItemInFront(feature)
          })
        } else {
          this.removeItemInFront(feature)
        }


      }

    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.productFeature.image = file;
      this.productFeature.preview = URL.createObjectURL(file);
    },
    productFeatureNameWrapper(product,featureProduct) {
      return Array.isArray(featureProduct) ? this.productFeatureName(product, featureProduct) : this.productFeatureName(product, featureProduct.id)
    }
  },
}
</script>

<style scoped>
.feature-image {
  object-fit: contain;
}

.feature-wrapper {
  background: rgba(253, 253, 253, 0.93);
}
</style>